const jobPlaceConfirmationDialogueBoxContent = {
  title: 'Are you ready to submit your first job?',
  subTitle:
    'You cannot edit the job details once you submit. We will start looking for the best qualified candidates based on your input.',
  submitButtonText: 'Submit free job',
  cancelButtonText: 'Cancel',
  submitAction: 'draft',
};
export default jobPlaceConfirmationDialogueBoxContent;
